import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  submitted = false;
  loading = false;
  errorMessage = '';
  emailSent = false;


  constructor(private angularFireAuth: AngularFireAuth, private formBuilder: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]] // email pattern
    });
  }

  get f() {
    return this.resetPasswordForm.controls;
  }


  async onSubmit() {
    try {
      this.submitted = true;
      this.loading = true;
      // stop here if form is invalid
      if (this.resetPasswordForm.invalid) {
        this.loading = false;
        return;
      }
      const email = this.f.email.value;
      await this.resetPasswordInit(email);
      this.emailSent = true;
    } catch (e) {
      console.log(e);
      this.errorMessage = e.message;
      this.loading = false;
      this.submitted = false;
    }
  }

  resetPasswordInit(email: string) {
    return this.angularFireAuth.sendPasswordResetEmail(email);
  }

}
